function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/iterableToArray.js
// module id = 85
// module chunks = 36573943044255 67936617089079 79611799117203